const config = [
  {
    component: 'ZlmTitle',
    options: {
      size: 'medium',
      text: '基本信息',
    },
  },
  {
    component: 'ZlmNormalDetail',
    options: {
      data: {},
    },
  },
  {
    component: 'ZlmTitle',
    options: {
      size: 'medium',
      text: '招标文件',
    },
  },
  {
    component: 'file-list',
    options: {
      groupId: '',
    },
  },
  {
    component: 'ZlmTitle',
    options: {
      size: 'medium',
      text: '招标文件附件',
    },
  },
  {
    component: 'file-list',
    options: {
      groupId: '',
    },
  },
  // {
  //   component: 'ZlmTitle',
  //   options: {
  //     size: 'medium',
  //     text: '附件信息',
  //   },
  // },
  // {
  //   component: 'ZlmNormalDetail',
  //   options: {
  //     data: {},
  //   },
  // },
  {
    component: 'ZlmTitle',
    options: {
      size: 'medium',
      text: '审核记录',
    },
  },
  {
    component: 'ZlmTabDetail',
    options: {
      title: '记录',
      data: [],
    },
  },
]

const { getApproveStatusName } = require('../approveStatus')

const mixin = {
  data() {
    return {
      config: JSON.parse(JSON.stringify(config)),
    }
  },
  methods: {
    getData() {
      this.getBaseInfo()
      this.$request
        .post(
          `/transformToAfter/app/track/zbggOverview`,
          {
            bdGuid: this.$route.query.id,
          },
          { showLoading: true },
        )
        .then((res) => {
          this.$request
            .post(`/transformToAfter/app/track/zbwjOverview`, {
              bdGuid: this.$route.query.id,
            })
            .then((res2) => {
              if (res2.data.zbwjGuid) {
                this.getApproveList(res2.data.zbwjGuid)
              } else {
                this.config.splice(4, 2)
              }
              this.config[1].options.data = {
                公告名称: res.data.ggName,
                项目名称: res.data.gcName,
                标段名称: res.data.bdName,
                标段编号: res.data.bdBH,
                获取开始时间: this.$util.timeFormatter(
                  res2.data.zbWJHuoQuStartTime,
                ),
                获取截止时间: this.$util.timeFormatter(
                  res2.data.zbWJHuoQuEndTime,
                ),
                澄清截止时间: this.$util.timeFormatter(
                  res2.data.zbwjYiYiEndTime,
                ),
                '截标/开标时间': this.$util.timeFormatter(res.data.kbTime),
              }
              // this.config[3].options.data = {
              //     '招标文件': '',
              //     '招标文件附件': '',
              //     '签章文件附件': '',
              // }
            })
        })
    },
    getBaseInfo() {
      this.$request
        .post(
          `/transformToAfter/app/bid/document/zbFileInfo`,
          {
            bdGuid: this.$route.query.id,
          },
          { showLoading: true },
        )
        .then((res) => {
          this.config[3].options.groupId = res.data.zbwjJsFuJian
          this.config[5].options.groupId = res.data.zbwjQiTaFuJian
          // this.config[7].options.groupId = res.data.signPdfGuid
          // this.config[3].options.data = {
          //   招标文件: '',
          //   招标文件附件: '',
          //   签章文件附件: '',
          // }
          // if (res.data.signPdfGuid) {
          //   this.$request
          //     .post(`/transformToAfter/guotou-file-business/getByFileGuid`, {
          //       fileInfoGuid: res.data.signPdfGuid,
          //     })
          //     .then((res2) => {
          //       console.log(res2.data)
          //       this.config[3].options.groupId = res2.data.groupGuid
          //       // console.log(res2.data.zbfaAttachmentGuid)
          //       // this.config[3].options.data['招标文件'] = res2.data.name
          //       // http://114.67.239.111:8043/file-web/downloadFile?guid=93f437f7-7924-4377-90e2-91b3d0d66a7d&token=fca3a63e-9d8c-4f39-b2ee-427236c65980"
          //     })
          // }
        })
    },
    getApproveList(guid) {
      this.$request
        .post(`/transformToAfter/app/approve/record/getApproveRecordByBusKey`, {
          businessKey: `ZBWenJian:${guid}`,
        })
        .then((res) => {
          if (res.data.length) {
            this.config[7].options.data = res.data.map((t) => ({
              提交人: t.commitUserName,
              提交时间: this.$util.timeFormatter(t.commitTime),
              审批人: t.approveUserName,
              审批结果: getApproveStatusName(t.statusMsg),
              审批时间: this.$util.timeFormatter(t.approveTime),
              审批意见: '',
              审批附件: '',
            }))
          }
        })
    },
  },
}

module.exports = {
  config,
  mixin,
}
